var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveYourPlans(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.793 6.4415C18.5696 6.4415 20.0138 4.9965 20.0138 3.22075C20.0138 1.44419 18.5688 0 16.793 0C15.0165 0 13.5723 1.445 13.5723 3.22075C13.5723 4.99731 15.0173 6.4415 16.793 6.4415ZM16.793 1.01339C18.0067 1.01339 19.0005 2.00193 19.0005 3.22091C19.0005 4.44076 18.012 5.42842 16.793 5.42842C15.5732 5.42842 14.5855 4.43989 14.5855 3.22091C14.5855 2.00105 15.574 1.01339 16.793 1.01339Z",
    fill: "url(#paint0_linear_9592_4445)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22075 13.5586C1.44419 13.5586 0 15.0036 0 16.7793C0 18.5559 1.445 20.0001 3.22075 20.0001C4.99731 20.0001 6.4415 18.5551 6.4415 16.7793C6.4415 15.0028 4.9965 13.5586 3.22075 13.5586ZM3.22075 18.9867C2.00706 18.9867 1.01324 17.9982 1.01324 16.7792C1.01324 15.5593 2.00177 14.5717 3.22075 14.5717C4.44061 14.5717 5.42827 15.5602 5.42827 16.7792C5.42827 17.999 4.43973 18.9867 3.22075 18.9867Z",
    fill: "url(#paint1_linear_9592_4445)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1096 9.49321H3.90228C3.13272 9.49321 2.40715 9.19331 1.86362 8.6489C1.31921 8.10449 1.01932 7.37893 1.01932 6.61025C1.01932 5.84069 1.32538 5.10895 1.86362 4.57159C2.40803 4.02718 3.1336 3.72729 3.90228 3.72729H9.45624L8.28653 4.897C8.08601 5.09752 8.08601 5.4159 8.28653 5.61642C8.48705 5.81694 8.80543 5.81694 9.00594 5.61642L11.0384 3.58393C11.239 3.38341 11.239 3.06503 11.0384 2.86452L9.00594 0.832032C8.80542 0.63151 8.48704 0.63151 8.28653 0.832032C8.08601 1.03255 8.08601 1.35093 8.28653 1.55145L9.45624 2.72116H3.90228C2.86448 2.72116 1.88208 3.12749 1.14421 3.86537C0.406326 4.60325 0 5.58564 0 6.62344C0 7.66124 0.406326 8.64363 1.14421 9.38151C1.88208 10.1194 2.86448 10.5257 3.90228 10.5257H16.1166C16.8861 10.5257 17.6117 10.8256 18.1552 11.37C18.6935 11.9083 18.9995 12.6523 18.9995 13.4087C18.9995 14.165 18.6996 14.9038 18.1552 15.4473C17.6108 15.9917 16.8853 16.2916 16.1166 16.2916H9.33038C9.04895 16.2916 8.8238 16.5168 8.8238 16.7982C8.8238 17.0797 9.04895 17.3048 9.33038 17.3048H16.1166C17.1614 17.3048 18.1368 16.8985 18.8747 16.1606C19.6125 15.4227 20.0189 14.4403 20.0189 13.4025C20.0189 12.3647 19.6125 11.3823 18.8747 10.6445C18.1368 9.90658 17.1544 9.50025 16.1166 9.50025L16.1096 9.49321Z",
    fill: "url(#paint2_linear_9592_4445)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9592_4445",
    x1: 15.1706,
    y1: 0.386614,
    x2: 18.3528,
    y2: 5.89837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9592_4445",
    x1: 1.59835,
    y1: 13.9452,
    x2: 4.78056,
    y2: 19.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9592_4445",
    x1: 4.96734,
    y1: 1.67935,
    x2: 12.3603,
    y2: 17.1001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveYourPlans);
export default __webpack_public_path__ + "static/media/ActiveYourPlans.3902449a942552f9ef972b9321a2e362.svg";
export { ForwardRef as ReactComponent };